import React, { Component, Fragment } from "react";
import { observer, inject } from "mobx-react";
import Header from "../../components/Header";
import Sidebar from "../../components/Sidebar";
import MainContainer from "../../components/MainContainer";
import Breadcrumb from "../../components/Breadcrumb";
import Heading from "../../components/Heading";
import Loading from "../../components/loadingSpinner/Loading";
import {
    Paper,
    Typography,
    TextField,
    Table,
    TableHead,
    TableRow,
    TableCell,
    TableBody,
    TableFooter,
    TablePagination,
    Toolbar
} from "@material-ui/core";
import InputAdornment from "@material-ui/core/InputAdornment";
import SearchIcon from "@material-ui/icons/Search";
import "../../components/admin/AdminTable.css";

@inject("profileStore")
@observer
class AdminActSearch extends Component {
    breadcrumb = [
        { name: "Dashboard", link: "/admin" },
        { name: "Act Search" }
    ];

    state = {
        isLoading: false,
        searchText: "",
        searchResults: [],
        page: 0,
        rowsPerPage: 10
    };

    handleSearchChange = (e) => {
        const value = e.target.value;
        this.setState({ searchText: value });

        if (value.length >= 3) {
            this.setState({ isLoading: true });
            this.props.profileStore.searchAct(value).then((results) => {
                const mappedResults = this.mapSearchResults(results || []);
                this.setState({
                    searchResults: mappedResults,
                    isLoading: false,
                    page: 0
                });
            }).catch(() => {
                this.setState({ isLoading: false, searchResults: [] });
            });
        } else if (value.length === 0) {
            this.setState({ searchResults: [], page: 0 });
        }
    };

    mapSearchResults = (results) => {
        return results.map(result => {
            const act = result.act || result;
            return {
                id: act.id,
                actName: act.actName || act.name || act.profileName || "-",
                ownerName: this.getOwnerName(act),
                ownerEmail: this.getOwnerEmail(act),
                ownerPhone: this.getOwnerPhone(act)
            };
        });
    };

    getOwnerName = (act) => {
        if (act.myMusician) {
            if (act.myMusician.fullName) {
                return act.myMusician.fullName;
            }
            if (act.myMusician.firstName || act.myMusician.lastName) {
                return ((act.myMusician.firstName || "") + " " + (act.myMusician.lastName || "")).trim();
            }
        }
        if (act.actAdmin) {
            if (act.actAdmin.fullName) {
                return act.actAdmin.fullName;
            }
            if (act.actAdmin.firstName || act.actAdmin.lastName) {
                return ((act.actAdmin.firstName || "") + " " + (act.actAdmin.lastName || "")).trim();
            }
        }
        if (act.contactPersonName) {
            return act.contactPersonName;
        }
        return "-";
    };

    getOwnerEmail = (act) => {
        if (act.contactEmail) {
            return act.contactEmail;
        }
        if (act.myMusician) {
            if (act.myMusician.email) return act.myMusician.email;
            if (act.myMusician.contactEmail) return act.myMusician.contactEmail;
            if (act.myMusician.profileEmail) return act.myMusician.profileEmail;
            if (act.myMusician.user && act.myMusician.user.email) return act.myMusician.user.email;
        }
        if (act.actAdmin) {
            if (act.actAdmin.email) return act.actAdmin.email;
            if (act.actAdmin.contactEmail) return act.actAdmin.contactEmail;
            if (act.actAdmin.user && act.actAdmin.user.email) return act.actAdmin.user.email;
        }
        if (act.user && act.user.email) {
            return act.user.email;
        }
        return "-";
    };

    getOwnerPhone = (act) => {
        if (act.contactPhone) {
            return act.contactPhone;
        }
        if (act.myMusician) {
            if (act.myMusician.phone) return act.myMusician.phone;
            if (act.myMusician.contactPhone) return act.myMusician.contactPhone;
            if (act.myMusician.phoneNumber) return act.myMusician.phoneNumber;
            if (act.myMusician.mobilePhone) return act.myMusician.mobilePhone;
        }
        if (act.actAdmin) {
            if (act.actAdmin.phone) return act.actAdmin.phone;
            if (act.actAdmin.contactPhone) return act.actAdmin.contactPhone;
            if (act.actAdmin.phoneNumber) return act.actAdmin.phoneNumber;
        }
        return "-";
    };

    handleChangePage = (event, newPage) => {
        this.setState({ page: newPage });
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({
            rowsPerPage: parseInt(event.target.value, 10),
            page: 0
        });
    };

    render() {
        const { isLoading, searchText, searchResults, page, rowsPerPage } = this.state;
        const paginatedResults = searchResults.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage);

        return (
            <Fragment>
                <Header />
                <Sidebar />
                <MainContainer>
                    <Breadcrumb links={this.breadcrumb} />
                    <Fragment>
                        <Heading title="Act Search">
                            <TextField
                                className="dark-datepicker"
                                placeholder="Search Act"
                                onChange={this.handleSearchChange}
                                value={searchText}
                                InputProps={{
                                    endAdornment: (
                                        <InputAdornment position="end">
                                            <SearchIcon style={{ color: "#ff0c9c" }} />
                                        </InputAdornment>
                                    )
                                }}
                            />
                        </Heading>
                        <Paper style={{ padding: 16 }}>
                            <Loading showed={isLoading} />

                            <div style={{ backgroundColor: "#F50E9C" }}>
                                <Toolbar style={{ minHeight: 48 }}>
                                    <Typography variant="subheading" style={{ color: "#fff" }}>
                                        Acts
                                    </Typography>
                                </Toolbar>
                            </div>

                            <div style={{ overflowX: "auto" }}>
                                <Table className="admin-table">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell style={{ fontWeight: 600 }}>Act Name</TableCell>
                                            <TableCell style={{ fontWeight: 600 }}>Act Owner Name</TableCell>
                                            <TableCell style={{ fontWeight: 600 }}>Owner Email</TableCell>
                                            <TableCell style={{ fontWeight: 600 }}>Owner Phone Number</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {paginatedResults.length > 0 ? (
                                            paginatedResults.map((act, index) => (
                                                <TableRow key={act.id || index} tabIndex={-1}>
                                                    <TableCell>
                                                        <Typography>{act.actName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>{act.ownerName}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>{act.ownerEmail}</Typography>
                                                    </TableCell>
                                                    <TableCell>
                                                        <Typography>{act.ownerPhone}</Typography>
                                                    </TableCell>
                                                </TableRow>
                                            ))
                                        ) : (
                                            <TableRow>
                                                <TableCell colSpan={4} align="center">
                                                    <Typography>
                                                        {searchText.length >= 3
                                                            ? "No acts found"
                                                            : "Enter at least 3 characters to search"}
                                                    </Typography>
                                                </TableCell>
                                            </TableRow>
                                        )}
                                    </TableBody>
                                    <TableFooter>
                                        <TableRow>
                                            <TablePagination
                                                colSpan={4}
                                                SelectProps={{ className: "transparent-select" }}
                                                count={searchResults.length}
                                                rowsPerPage={rowsPerPage}
                                                page={page}
                                                backIconButtonProps={{
                                                    "aria-label": "Previous Page"
                                                }}
                                                nextIconButtonProps={{
                                                    "aria-label": "Next Page"
                                                }}
                                                onChangePage={this.handleChangePage}
                                                onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                            />
                                        </TableRow>
                                    </TableFooter>
                                </Table>
                            </div>
                        </Paper>
                    </Fragment>
                </MainContainer>
            </Fragment>
        );
    }
}

export default AdminActSearch;
